"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var react_router_dom_1 = require("react-router-dom");
var utils_1 = require("../../../utils");
var MenuItem_1 = __importDefault(require("../MenuItem"));
var styles_1 = require("../SharedStyles/styles");
var SubMenuItem_1 = __importDefault(require("../SubMenuItem"));
var utils_2 = require("../utils");
var hooks_1 = require("../hooks");
var consts_1 = require("../consts");
var styles_2 = require("./styles");
var LinkListMenu = function (_a) {
    var label = _a.label, icon = _a.icon, items = _a.items, basePath = _a.basePath, testId = _a.testId, expandedMenu = _a.expandedMenu, setExpandedMenu = _a.setExpandedMenu, id = _a.id, trailingIcon = _a.trailingIcon, isBasePathLinkOff = _a.isBasePathLinkOff;
    var _b = (0, react_1.useState)(false), isPopupOpen = _b[0], setIsPopupOpen = _b[1];
    var _c = (0, hooks_1.useSidebarState)(), isSidebarOpen = _c.isSidebarOpen, setIsSidebarOpen = _c.setIsSidebarOpen, isServiceAndInfoSubmenuOpen = _c.isServiceAndInfoSubmenuOpen, setIsServiceAndInfoSubmenuOpen = _c.setIsServiceAndInfoSubmenuOpen;
    var isServiceAndInfo = id === consts_1.SERVICE_AND_INFO_MENU_ID;
    var storedServiceInfoState = localStorage.getItem('isServiceAndInfoSubmenuOpen') === 'true';
    var isMenuExpanded = isServiceAndInfo ? isServiceAndInfoSubmenuOpen || storedServiceInfoState : expandedMenu === id;
    var setServiceAndInfoMenuStateWithLocalstorage = function (isOpen) {
        setIsServiceAndInfoSubmenuOpen(isOpen);
        if (isOpen) {
            localStorage.setItem('isServiceAndInfoSubmenuOpen', 'true');
        }
        else {
            localStorage.setItem('isServiceAndInfoSubmenuOpen', 'false');
        }
        window.dispatchEvent(new CustomEvent(consts_1.SIDEBAR_SERVICE_AND_INFO_SUBMENU_EVENT_NAME, {
            detail: { isOpen: isOpen },
        }));
    };
    var setServiceAndInfoMenuState = function (isOpen) {
        setIsServiceAndInfoSubmenuOpen(isOpen);
        window.dispatchEvent(new CustomEvent(consts_1.SIDEBAR_SERVICE_AND_INFO_SUBMENU_EVENT_NAME, {
            detail: { isOpen: isOpen },
        }));
    };
    var toggleExpanded = function () {
        if (isSidebarOpen) {
            if (!isMenuExpanded) {
                if (isServiceAndInfo) {
                    setServiceAndInfoMenuStateWithLocalstorage(true);
                }
                setExpandedMenu(id);
            }
            else {
                if (isServiceAndInfo) {
                    setServiceAndInfoMenuStateWithLocalstorage(false);
                }
                setExpandedMenu(null);
            }
        }
        else {
            setIsPopupOpen(function (prev) { return !prev; });
        }
    };
    var _d = (0, react_1.useState)(false), isOnBasePath = _d[0], setIsOnBasePath = _d[1];
    var isOnSubPath = window.location.pathname.includes(basePath) && window.location.pathname !== basePath;
    (0, react_1.useEffect)(function () {
        if (isSidebarOpen && isOnSubPath && window.innerWidth >= 768) {
            setExpandedMenu(id);
        }
    }, [isSidebarOpen]);
    (0, utils_1.useOnPathnameChange)(function () {
        var currentPath = window.location.pathname;
        setIsOnBasePath(currentPath.includes(basePath));
        if (currentPath === consts_1.SERVICE_AND_INFO_PATH && isServiceAndInfo) {
            setServiceAndInfoMenuState(true);
        }
        else if (!currentPath.startsWith(consts_1.SERVICE_AND_INFO_PATH) &&
            isServiceAndInfoSubmenuOpen &&
            !storedServiceInfoState) {
            setServiceAndInfoMenuState(false);
        }
    });
    var isActive = isMenuExpanded || isPopupOpen || isOnBasePath;
    var menuItemRef = (0, react_1.useRef)(null);
    var menuDropdownRef = (0, react_1.useRef)(null);
    var menuPopupRef = (0, react_1.useRef)(null);
    var popupPosition = (0, utils_2.getPopupPosition)(menuItemRef, 'top');
    var onClickOutside = (0, react_1.useCallback)(function () {
        setIsPopupOpen(false);
    }, [isSidebarOpen, isMenuExpanded, isOnSubPath]);
    var onSubmenuItemClick = function () {
        if (!isServiceAndInfo) {
            setServiceAndInfoMenuState(false);
        }
        setIsPopupOpen(false);
        if (window.innerWidth < 768) {
            setExpandedMenu(null);
            setIsSidebarOpen(false);
            localStorage.setItem('isSidebarOpen', 'false');
            window.dispatchEvent(new CustomEvent(consts_1.SIDEBAR_STATE_CHANGE_EVENT_NAME, {
                detail: { newState: false },
            }));
        }
    };
    (0, utils_1.useOnClickOutside)([menuItemRef, menuDropdownRef, menuPopupRef], onClickOutside);
    var linkMenuList = items.map(function (_a) {
        var key = _a.key, label = _a.label, to = _a.to, itemTestId = _a.testId, trailingIcon = _a.trailingIcon, isTargetBlank = _a.isTargetBlank;
        return ((0, jsx_runtime_1.jsx)(SubMenuItem_1.default, { isOpen: isSidebarOpen, label: label, to: to, onClick: onSubmenuItemClick, testId: "".concat(testId, "-").concat(itemTestId !== null && itemTestId !== void 0 ? itemTestId : key), trailingIcon: trailingIcon, isTargetBlank: isTargetBlank, tabIndex: isMenuExpanded || isPopupOpen ? 0 : -1 }, key));
    });
    var handleClick = function () {
        if (isBasePathLinkOff) {
            toggleExpanded();
        }
        else if (isSidebarOpen) {
            if (isServiceAndInfo) {
                setServiceAndInfoMenuState(true);
            }
            setExpandedMenu(id);
        }
        else {
            setIsPopupOpen(true);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styles_2.InnerContainer, { children: (0, jsx_runtime_1.jsx)(MenuItem_1.default, { label: label, icon: icon, to: isBasePathLinkOff ? undefined : basePath, onClick: handleClick, isActive: isActive, isExpandable: true, forwardRef: menuItemRef, testId: testId, onExpandToggle: toggleExpanded, isMenuOpen: isMenuExpanded || isPopupOpen, trailingIcon: trailingIcon, autoFocusId: "".concat(testId, "-").concat(items[0].testId || items[0].key) }) }), (0, jsx_runtime_1.jsx)(styles_1.ExpandableListContainer, __assign({ className: (0, classnames_1.default)({ open: isMenuExpanded && isSidebarOpen }), ref: menuDropdownRef }, { children: linkMenuList })), (0, jsx_runtime_1.jsxs)(styles_1.ClosedPopupContainer, __assign({ popupBottomPosition: popupPosition, className: (0, classnames_1.default)({ visible: isPopupOpen && !isSidebarOpen }), ref: menuPopupRef }, { children: [isBasePathLinkOff ? ((0, jsx_runtime_1.jsx)(styles_2.SubmenuContainer, __assign({ className: "inactive" }, { children: label }))) : ((0, jsx_runtime_1.jsx)(styles_2.SubmenuContainer, __assign({ end: true, as: react_router_dom_1.NavLink, to: isBasePathLinkOff ? '' : basePath }, { children: label }))), linkMenuList] }))] }));
};
exports.default = LinkListMenu;
